import { IFloatingRateResponse } from "../company/IFloatingRateResponse"

export enum ICalculateReplenishmentRateType {
  Base = "BASE",
  Client = "CLIENT",
  Volume = "VOLUME",
  Amount = "AMOUNT",
  Personal = "PERSONAL"
}

export interface ICalculateReplenishmentResponse {
  floatingRates: IFloatingRateResponse
  baseAmount: string
  usdAmount: string
  rubAmount: string
  invoiceAmount: string
  baseRate: string

  invoiceRate: string
  brockmanRate: string

  calculationRate: string
  rateType: ICalculateReplenishmentRateType
}
